import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../../store/store"

const commonSlice = createSlice({
    name: "common",
    initialState: { selectedLanguage: null, locationModal: null } as {
        selectedLanguage: null | any | undefined,
        locationModal: null | any | undefined

    },
    reducers: {
        setSelectedLanguage: (state, { payload: { selectedLanguage } }: PayloadAction<{ selectedLanguage: null | any[] | undefined }>) => {
            state.selectedLanguage = selectedLanguage
        },
        setLocationModal: (state, { payload: { locationModal } }: PayloadAction<{ locationModal: null | boolean | undefined }>) => {
            state.locationModal = locationModal
        },
    },
})

export const { setSelectedLanguage, setLocationModal } = commonSlice.actions

export default commonSlice.reducer
export const getSelectedLanguage = (state: RootState) => state.common.selectedLanguage
export const getLocationModal = (state: RootState) => state.common.locationModal
